// This will output only the hours and minutes for the end time if both start_time and end_time are on the same day
const DateAndTime = (start, end) => {
    start = start.replace(/-/g, "/")
    end = end.replace(/-/g, "/")
    const dateOptions = { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute:'2-digit' };
    const startTime  = new Date(start).toLocaleDateString("en-GB", dateOptions)
    const endTime  = 
        // If it's the same day - https://flaviocopes.com/how-to-check-dates-same-day-javascript/
        new Date(start).getFullYear() === new Date(end).getFullYear() && new Date(start).getMonth() === new Date(end).getMonth() && new Date(start).getDate() === new Date(end).getDate() ?
        // Just hours and minutes
        new Date(end).toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' }) :
        // Full date
        new Date(end).toLocaleDateString("en-GB", dateOptions)

    return `${startTime} - ${endTime}`
}

export default DateAndTime